import styled from "styled-components";
import { Box, Text } from "@vinomofo/components";
import ReactPlayer from "react-player";

export interface VideoBlockProps {
  url: string;
  caption: string;
}

const PlayerWrapper = styled.div`
  position: relative;
  padding-top: 56.25%;
`;

const ReactPlayerStyled = styled(ReactPlayer)`
  position: absolute;
  top: 0;
  left: 0;
`;

export const VideoBlock = ({ url, caption }: VideoBlockProps): JSX.Element => {
  return (
    <Box
      textAlign="center"
      marginBottom={caption ? 20 : 0}
      mx={[-20, 0]}
      overflow="hidden"
      maxHeight={"auto"}
    >
      <PlayerWrapper>
        <ReactPlayerStyled
          className="react-player"
          url={url}
          width="100%"
          height="100%"
        />
      </PlayerWrapper>
      {caption && (
        <Box
          position="relative"
          top={-23}
          px="16px"
          py="8px"
          backgroundColor="mofoPrimary"
          maxWidth="80%"
          display="inline-block"
          as="figcaption"
          alignItems="center"
        >
          <Text color="white" variant="sm">
            {caption}
          </Text>
        </Box>
      )}
    </Box>
  );
};
